import {ListEntryWithID} from '@app/shared/list/list.component';
import {KeyValue} from '@pezi/entities';
import {createStore} from "@ngneat/elf";
import {withEntities} from "@ngneat/elf-entities";
import {persistState, sessionStorageStrategy} from "@ngneat/elf-persist-state";
import {Injectable} from "@angular/core";

export interface SearchResultHistory {
  id: string;
  results: ListEntryWithID<any>[];
  search?: KeyValue<string, any>[];
}

@Injectable({providedIn: 'root'})
export class SearchResultHistoryStore {

  data = createStore({name: 'search-result-history'}, withEntities<SearchResultHistory>());
  persist = persistState(this.data, {
    key: 'search-result-history',
    storage: sessionStorageStrategy,
  });

}

